function removeData(chart) {
    chart.data.labels.pop();
    chart.data.datasets.forEach((dataset, index) => {
        dataset.data.pop();
        if (dataset.data) {
            removeData(chart);
        }
    });
    chart.update();
}

function priceUpdate() {
    if ($('.variant-items.is-active').length > 0) {
        var mprice = $('.variant-items.is-active').data('variant-original-price');
    } else {
        var mprice = 0;
    }
    if ($('.widget--adons').children('input[checked="checked"]').length > 0) {
        var addonprice = $('.widget--adons').children('input[checked="checked"]').data('variant-price');
    } else {
        var addonprice = 0;
    }
    var sum = parseInt(mprice + addonprice);
    var variantId = $('.variant-items.is-active').attr('data-variantId');
    $('.price-item--regular').html('$' + parseFloat(sum / 100).toFixed(2));
    $('.product-form').find('[name="id"]').val(variantId);

    $('.affirm-as-low-as').attr('data-amount', mprice);

    affirm.ui.refresh();

}

function addExtra(v_id) {
    data = {
        "quantity": 1,
        "id": v_id
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            var v_id = $('.variant-items.is-active').data('variantId');
            addItemToCart(v_id, 1);
        }
    });
}

$(document).ready(function() {


});

$('.js--tune-product--slider').slick({
  arrows: true,
  centerMode: true,
  centerPadding: '21vw',
  slidesToShow: 1,
  asNavFor: '.js--tune-product-selection',
  infinite: false,
  initialSlide: 1,
  autoplay: false,
  responsive: [{
    breakpoint: 768,
    settings: {
      centerPadding: '20px',
    }
  }]
});

$('.js--tune-product-selection').slick({
    arrows: true,
    centerMode: true,
    centerPadding: '21vw',
    slidesToShow: 1,
    asNavFor: '.js--tune-product--slider',
    fade: true,
    initialSlide: 1,
    infinite: false,
    draggable: false,
    swipe: false,
    autoplay: false,
    responsive: [{
        breakpoint: 768,
        settings: {
            centerPadding: '20px'
        }
    }]
});

$('.js--submenu-maker-slider').slick({
    arrows: false,
    slidesToShow: 1,
    fade: true,
    infinite: false,
    draggable: false,
    swipe: false,
    autoplay: false,
    responsive: [{
        breakpoint: 768,
        settings: {}
    }]
});

$(document).on('click', '.stamped-main-badge', function() {
  var target = $('#product-reviews');
  target = target.length ? target : $('[name=' + this.hash.substr(1) + ']');
  if (target.length) {
    $('html, body').animate({
      scrollTop: target.offset().top - 70
    }, 1500);
    return false;
  }
});


// Variant Change Custom JS || Dotmagic Uday

$('.variant-radios-boxs .variant-items').click(function() {
    $('.variant-radios-boxs .variant-items').removeClass('is-active')
    $(this).addClass('is-active');
    const dataHorsePower = $(this).data('v-horsepower'),
        dataTorque = $(this).data('v-torque');
    dataHorsePower != '' ? $(`.dm_change_horsepower`).attr('data-product-dme-horsepower', dataHorsePower) : '';
    dataHorsePower != '' ? $(`.dm_change_horsepower[data-product-dme-horsepower=${dataHorsePower}]`).text(dataHorsePower) : '';
    dataTorque != '' ? $(`.dm_change_torque`).attr('data-product-dme-torque', dataTorque) : '';
    dataTorque != '' ? $(`.dm_change_torque[data-product-dme-torque=${dataTorque}]`).text(dataTorque) : '';
    priceUpdate();
    variantChange();
});

var maxHorsePower = 1500;
if($("body").hasClass("template-product-Turbokits")){
  maxHorsePower = 2000;
  if($(window).width() < 640){
    maxHorsePower = 2300;
  }
}
const variantChange = () => {
    $('.variant-factor-main').each(function(e) {
        const getSelector = $(this).find('.variant-factory-content .variant-figures-main'),
            getSelector2 = $(this).find('.variant-dme-content .variant-figures-main'),
            getIdSelector = $(this).find('canvas').attr('id'),
            getPower = getSelector.attr('data-product-horsepower') || getSelector.attr('data-product-torque'),
            getPowerSum = (getSelector.attr('data-product-horsepower') * 600) / maxHorsePower || (getSelector.attr('data-product-torque') * 600) / maxHorsePower,
            getPowerDME = getSelector2.attr('data-product-dme-horsepower') || getSelector2.attr('data-product-dme-torque'),
            power = getPowerDME - getPower,
            powerSum = (power * 600) / maxHorsePower,
            txt = e === 0 ? 'HP' : 'TQ';
        changeProgress(getPowerSum, powerSum, getIdSelector, txt, power);
    })
}

const changeProgress = (getPower, powerSum, Id, txt, power) => {
    var canvas = document.getElementById(Id),
        canvasContent = canvas.getContext("2d");

    const skillBars = [];
    skillBars.push({
        max: getPower,
        color: "#fff"
    });
    skillBars.push({
        max: powerSum,
        color: "#00f"
    });

    let chartBottomY = 36,
        chartBarPadding = 0,
        percent = 0;

    const animate = () => {
        if ((percent++) < 100) {
            percent = percent + 2;
            requestAnimationFrame(animate);
        }

        canvasContent.clearRect(0, 0, canvas.width, canvas.height);
        var x = chartBarPadding;
        var y = chartBarPadding;

        let height2 = (skillBars[1].max * percent) / 100;
        let height = (skillBars[0].max * percent) / 100;
        if (height2 > skillBars[0].max + skillBars[1].max) {
            height2 = skillBars[0].max + skillBars[1].max;
        }
        canvasContent.fillStyle = skillBars[1].color;
        canvasContent.fillRect(y, chartBottomY, height + height2, -chartBottomY);
        y += x;

        if (height > skillBars[0].max) {
            height = skillBars[0].max;
        }
        canvasContent.fillStyle = skillBars[0].color;
        canvasContent.fillRect(x, chartBottomY, height, -chartBottomY);
        x += skillBars[0].max + chartBarPadding;

        var fontSize = ($(window).width() > 481) ? '16px GTWalsheimProRegular' : '20px GTWalsheimProRegular';
        if (height == skillBars[0].max) {
            canvasContent = canvas.getContext('2d');
            canvasContent.fillStyle = "#fff";
            canvasContent.textBaseline = "middle";
            canvasContent.font = fontSize;
            canvasContent.fillText('+' + power + txt, (skillBars[0].max + skillBars[1].max) + 20, 19);
        }
    }
    animate();
}

variantChange();


